import React from 'react';
import { Motion, spring } from 'react-motion';

import { classes as cn } from 'shared/styles';
import { getSelectionBoundingRect } from 'shared/helpers';
import { SvgIcon } from 'components/elems';
import { BASE_COLOR as BC } from 'shared/constants/colors';

import { cx } from 'helpers';


const TRACKING_DOT_SIZE = 5;

const PlaceholderShadow = ({ placeholder }) => {
  if (!placeholder) return null;

  return (
    <Motion
      defaultStyle={{ opacity: 0 }}
      style={{
        opacity: spring(1, { stiffness: 250, damping: 13 })
      }}
    >
      {({opacity}) => {
        return (
          <div style={{ opacity }}>
            {placeholder}
          </div>
        );
      }}
    </Motion>
  );
};


const RightSideRail = ({children}) => {
  const selRect = getSelectionBoundingRect();

  const top = (selRect
    ? (selRect.height/2 - TRACKING_DOT_SIZE/2)
    : 0
  );

  return (
    <div
      className="absolute right-0 flex"
      style={{ top }}
    >
      {children}
    </div>
  );
};

const TrackingDot = ({children}) => (
  <SvgIcon.fa.Circle
    className={cn.animateFadeInSlow}
    style={{ color: BC.caretBlue }}
    size={TRACKING_DOT_SIZE}
  />
);


const CaretShadowFrame = ({
  position = {},
  placeholder = null,
  hasTrackingDot = false,
  children,
}) => {
  if (position.top === undefined) return null;
  if (position.left === undefined) return null;

  return (
    <div
      contentEditable={false}
      className={cx(
        "-typography-base",
        "absolute flex items-center nowrap transparent",

        // Otherwise typeahead shows below headline..
        "z-1",

        // If placeholder, make it not clickable..
        {"pointer-events-none": !!placeholder},
      )}
      style={{
        // Override -typography-base to position exactly
        // over paragraph.
        lineHeight: 1,

        // From where selection is all the way to right
        width: `calc(100% - ${position.left})`,

        // XXX(tyu): There is this obscure thing that's
        // happening with MediumRareEditor, where b/c of
        // debouncing of updating position, placeholder text
        // can flash for a split second before appearing in the
        // right position. With the combination of css color
        // transition AND Motion, we can mitigate this..
        // Weird, but oh well..
        transition: 'color 200ms ease-in-out',
        color: placeholder ? BC.moonGray : 'transparent',

        ...position
      }}
    >
      {children}

      <PlaceholderShadow placeholder={placeholder} />

      <RightSideRail>
        {hasTrackingDot && <TrackingDot />}
      </RightSideRail>
    </div>
  );
};


export {
  CaretShadowFrame,
}



// WEBPACK FOOTER //
// ./src/components/slate/decors/CaretShadow.js